module.exports = __webpack_public_path__ + "img/eye-open.dee91cd0.svg";